export default __webpack_public_path__ + "static/media/warning--loop-pretzel--g1.ec181bb6.png";